import * as types from '../actions/actionTypes'
import { Businesses } from '../config/Helper';
import initialState from './initialState'

export default function setSideActivities(state = { items: [] }, action) {
    switch (action.type) {
        case types.SET_SIDE_ACTIVITIES:
            return {
                items: action.items
            }
        default:
            return state;
    }
}
